// extracted by mini-css-extract-plugin
module.exports = {"Custom404":"Custom404_Custom404__wQZNq","spooky":"Custom404_spooky__uj_NN"};